import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import { onUpdated, onMounted } from 'vue';
    import { storeToRefs } from 'pinia';
    import { useAuth } from '@/stores/auth';
    import { TopNavBar, Sidebar, AppTitle, LoginModal } from '@/components';

    
export default /*#__PURE__*/_defineComponent({
  __name: 'Wrapper',
  setup(__props) {

    const authState = useAuth();
    const { authenticated } = storeToRefs(authState);
    const { checkServerAuthStatus } = authState;

    onMounted(() => checkServerAuthStatus());
    onUpdated(() => checkServerAuthStatus());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(TopNavBar)),
    _createVNode(_unref(LoginModal), {
      show: !_unref(authenticated)
    }, null, 8, ["show"]),
    _createElementVNode("div", {
      class: _normalizeClass(["wrapper", [!_unref(authenticated) ? 'blur' : null]])
    }, [
      _createVNode(_unref(AppTitle)),
      _createVNode(_unref(Sidebar)),
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 64))
}
}

})